import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { DatePicker } from 'antd';
import dayjs, { Dayjs } from "dayjs";
const DateTableFilter = ({ placeholder, defaultValue, onApplyFilter, onClearFilter }) => {
    const onChange = (date /*, dateString: string | string[]*/) => {
        if (date) {
            onApplyFilter([date.format("YYYY-MM-DD")]);
        }
        else {
            onClearFilter();
        }
    };
    const dateValue = defaultValue ? dayjs(defaultValue + "") : null;
    return (_jsx("div", { className: "swz-calendar-filter-dropdown custom-filter-dropdown", children: _jsx(DatePicker, { placeholder: placeholder ?? undefined, format: 'DD/MM/YYYY', showNow: true, defaultValue: dateValue, allowClear: true, onChange: onChange }) }));
};
export default DateTableFilter;
